import { Box, Divider, Typography } from "@mui/material";
import React from "react";

function NpdOrdersPage() {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "start",
          gap: "12px",
        }}
      >

        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "4rem 0",
          }}
        >
          <Typography
            sx={{
              fontFamily: "poppins",
              fontWeight: "400",
              fontSize: "18px",
              color: "#666",
            }}
          >
            🚧 Feature Coming Soon...
          </Typography>
        </Box>
      </Box>

      <Divider
        sx={{
          margin: "1.5rem -2rem",
          height: "4px",
          background: "#0D0D0D",
          border: "none",
        }}
      />
    </>
  );
}

export default NpdOrdersPage;
